{{#if source}}
<div class="data-source">Source: {{{source}}}</div>
{{/if}}
{{#if notes}}
<div class="data-notes">Notes: {{{notes}}}</div>
{{/if}}
{{{context}}}
